import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { buildApiUrl, authHeaders } from "../config/api";
import "../styles/adminUsuarios.css";

const SERVICE_STATUS_LABELS = {
  habilitado: "Servicio habilitado",
  suspendido: "Servicio suspendido",
  aviso_suspension: "Aviso de suspensión de servicio",
};

export const AdminUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const cargarUsuarios = async () => {
    setIsLoading(true);
    setErrorMessage("");
    try {
      const response = await axios.get(buildApiUrl("/ep_AdminUsers/ListUsers"), {
        headers: authHeaders(),
      });
      setUsuarios(response.data);
    } catch (error) {
      if (error.response?.status === 401 || error.response?.status === 403) {
        navigate("/store");
        return;
      }
      setErrorMessage("Ocurrió un error al cargar los usuarios.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    cargarUsuarios();
  }, []);

  const handleServiceStatusChange = async (organizationID, serviceStatus) => {
    try {
      await axios.put(
        buildApiUrl("/ep_AdminUsers/UpdateServiceStatus"),
        { OrganizationID: organizationID, ServiceStatus: serviceStatus },
        { headers: authHeaders() },
      );
      setUsuarios((prev) =>
        prev.map((usuario) =>
          usuario.OrganizationID === organizationID
            ? { ...usuario, ServiceStatus: serviceStatus }
            : usuario,
        ),
      );
    } catch (error) {
      setErrorMessage("No se pudo actualizar el status del usuario.");
    }
  };

  return (
    <div className="adminUsuarios_container">
      <div className="adminUsuarios_container_h2">
        <h2>Usuarios de la plataforma</h2>
      </div>

      {errorMessage && (
        <div className="alert alert-danger adminUsuarios_alert">{errorMessage}</div>
      )}

      <div className="adminUsuarios_tabla_wrapper">
        <table className="adminUsuarios_tabla">
          <thead className="adminUsuarios_tabla_title">
            <tr>
              <th>NOMBRE</th>
              <th>EMAIL</th>
              <th>ORGANIZATION ID</th>
              <th>TIPO DE ORGANIZACIÓN</th>
              <th>ROL</th>
              <th>STATUS DE SERVICIO</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={6}>Cargando usuarios...</td>
              </tr>
            ) : usuarios.length === 0 ? (
              <tr>
                <td colSpan={6}>No hay usuarios registrados.</td>
              </tr>
            ) : (
              usuarios.map((usuario) => (
                <tr key={usuario.OrganizationID} className="adminUsuarios_tabla_fila">
                  <td>{usuario.Name}</td>
                  <td>{usuario.Email}</td>
                  <td>{usuario.OrganizationID}</td>
                  <td>{usuario.tipoOrganizacion}</td>
                  <td>{usuario.Role}</td>
                  <td>
                    <select
                      className={`adminUsuarios_select_status adminUsuarios_select_status--${usuario.ServiceStatus}`}
                      value={usuario.ServiceStatus}
                      onChange={(e) =>
                        handleServiceStatusChange(usuario.OrganizationID, e.target.value)
                      }
                    >
                      {Object.entries(SERVICE_STATUS_LABELS).map(([value, label]) => (
                        <option key={value} value={value}>
                          {label}
                        </option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
